module.exports = __webpack_public_path__ + "img/the-film.04079921.jpeg";